import {flatten} from '@angular/compiler';
import {cloneDeep, isEmpty, remove} from 'lodash';
import {RatingLabels} from '../../model/rating-labels.model';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PreferredCategories, Rating} from '../../model/portfolio-preferences.model';

@Component({
    selector: 'app-rating-selector',
    templateUrl: './rating-selector.component.html',
    styleUrls: ['./rating-selector.component.scss']
})
export class RatingSelectorComponent {
    private static readonly ForbiddenRatings = [Rating.B4, Rating.B5, Rating.B6];
    public readonly availablePreferences = RatingLabels.defaults();
    @Input()
    public readonly preferredCategories: PreferredCategories[] = [];
    @Output()
    public readonly preferredCategoriesChange = new EventEmitter<PreferredCategories[]>();
    @Input()
    public readonly forbiddenRatingsAlertType: 'warn' | 'error' = 'warn';

    ngOnInit(): void {
        this.setDefaultPreference();
    }

    setCustomPortfolioPreference(preference: PreferredCategories, isSelected: boolean): void {
        this.removePreferences(preference);
        if (isSelected) {
            this.preferredCategories.push(cloneDeep(preference));
        }
        this.preferredCategoriesChange.emit(this.preferredCategories);
    }

    isCategorySelected(preference: PreferredCategories): boolean {
        return !!this.preferredCategories.find(eachCategory => {
            return preference.ratingList.every(r => {
                return eachCategory.ratingList.map(value => value.toString()).includes(r);
            });
        });
    }

    public containsOnlyForbiddenRatings(preferredCategories: PreferredCategories[] = this.preferredCategories) {
        return this.convertPreferredCategoriesToRatings(preferredCategories)
            .every(rating => RatingSelectorComponent.ForbiddenRatings.includes(rating));
    }

    public areCategoriesEmpty(preferredCategories: PreferredCategories[]) {
        return isEmpty(this.convertPreferredCategoriesToRatings(preferredCategories)) || this.convertPreferredCategoriesToRatings(preferredCategories).length < 12;
    }

    private setDefaultPreference(): void {
        if(this.preferredCategories && this.preferredCategories[0].ratingList && this.preferredCategories[0].ratingList.length) {
            return;
        } else {
            let defaultRatingToBeSelected: PreferredCategories = {ratingList: this.getAllDefaultPreferences()};
            this.setCustomPortfolioPreference(defaultRatingToBeSelected, true);
        }
    }

    private convertPreferredCategoriesToRatings(preferredCategories: PreferredCategories[]) {
        return flatten(preferredCategories.map(category => category.ratingList));
    }

    private removePreferences(preference: PreferredCategories) {
        this.preferredCategories.forEach(selectedCategory => {
            remove(selectedCategory.ratingList, (item) => preference.ratingList.includes(item));
        });
        remove(this.preferredCategories, cat => isEmpty(cat.ratingList));
    }

    private getAllDefaultPreferences(): Rating[] {
        return Array.from(new Set<Rating>(Object.values(Rating)));
    }
}